export const PHOTO_PICKER_ROTATE_DEGREES = 90;
export const PHOTO_PICKER_PICKED_IMAGE_MAX_SIZE = 1920;
export const PHOTO_PICKER_CANVAS_SIZE_DEFAULT = 220;
export const PHOTO_PICKER_MIN_WIDTH_DEFAULT = 480;
export const PHOTO_PICKER_MIN_HEIGHT_DEFAULT = 480;
export const PHOTO_PICKER_CROPBOX_TO_CANVAS_RATE = 0.866666666666667;
